import React from 'react';
import { terms as t } from '../index';
import { medianPrice } from './medianPrice';
import { soldAvgVsMedianPrice } from './soldAvgVsMedianPrice';
import { avg$Sqft } from './averageDollarSqft';
import { supplyAmpDemandNumUnits } from './supplyAmpDemandNumUnits';
import { avgDomCdom } from './averageDomCdom';
import { monthlySupplyOfInventory } from './monthlySupplyOfInventory';
import { underContractUc } from './underContract'
import { avgSpLpComparison } from './avgSpLpComparison';
import { salesAbsorption } from './salesAbsorption';
import { avgSpOpAllProperties } from './avgSpOpAllProperties';
import { avgSpOpComparison } from './avgSpOpComparison';
import { forSaleVsFsldm } from './forSaleVsFsldm';
import { cdomBreakout } from './cdomBreakout';
import MarketDynamicsPeriod from '../../../common/components/table/cellRenderers/MarketDynamicsPeriod';
import { listingStatuses as ls } from '../listingStatuses';

const initialListingsbreakdownTab = 1;

export const cleanListingViews = Object.freeze({
    avg$Sqft,
    avgDomCdom,
    avgSpLpComparison,
    avgSpOpComparison,
    avgSpOpAllComparison: { label: t.avgSpOpAllComparison, value: 'avgSpOpAllComparison' },
    avgSpOpAllProperties,
    cdomBreakout,
    forSaleVsFsldm,
    medianPrice,
    monthlySupplyOfInventory,
    overview: { label: t.overview, value: 'overview' },
    salesAbsorption,
    soldAvgVsMedianPrice,
    supplyAmpDemandNumUnits,
    underContractUc
});

export const listingViews = Object.fromEntries(
    Object.entries(cleanListingViews).map(([key, value]) => {
        const tablesWithCellRenderer = value.tableSettings?.tables.map(table =>
            table.col?.id === 'timePeriodStart'
                ? ({
                    ...table,
                    cellRenderer: (props) => <MarketDynamicsPeriod {...props} />
                }) : table);
        return [
            key,
            key !==  cdomBreakout.value
                ? {
                    ...value,
                    tableSettings: {
                        ...value.tableSettings,
                        tables: tablesWithCellRenderer,
                    }
                } : value
        ];
    })
);

const buildTab = ({
    listingStatus,
    tableTitleWithTooltips,
    searchCriteria,
    component,
    gridRefs,
    tabIndex = 1,
    isOfficeListing,
}) => ({
    title: t.getListingTitle(listingStatus.label),
    content: {
        jsx: component({
            listingStatus,
            tableTitleWithTooltips,
            searchCriteria,
            tabIndex,
            gridRef: (ref) => (gridRefs.current[tabIndex] = ref),
            isOfficeListing
        })
    }
});

const getForSaleLastDayOfTheMonthTab = (args) => buildTab({...args, listingStatus: ls.forSaleLdm});
const getUnderContractsTab = (args) => buildTab({...args, listingStatus: ls.underContract});
const getForSaleTab = (args) => buildTab({...args, listingStatus: ls.forSale});
const getSoldTab = (args) => buildTab({...args, listingStatus: ls.sold});

const buildmonthlySupplyOfInventoryTabs = ({checkedStatusOptions, ...args}) => {
    const hasMsiSold = !!checkedStatusOptions.find(item => item.id === ls.msiSold.id);
    const hasUnderContractMsi = !!checkedStatusOptions.find(item => item.id === ls.underContractMsi.id);
    const tabs = [];
    let tabIndex = initialListingsbreakdownTab;
    if (hasMsiSold){
        tabs.push(getSoldTab({...args, tabIndex}));
        tabIndex++;
    }
    tabs.push(getForSaleLastDayOfTheMonthTab({...args, tabIndex})),
    tabIndex++;
    hasUnderContractMsi && tabs.push(getUnderContractsTab({...args, tabIndex}));
    return tabs;
};

const buildSalesAbsortionTabs = ({checkedStatusOptions, ...args}) => {
    const hasUnderContract = !!checkedStatusOptions.find(item => item.id === ls.underContract.id);
    const hasSold = !!checkedStatusOptions.find(item => item.id === ls.sold.id);
    const tabs = [];
    let tabIndex = initialListingsbreakdownTab;
    tabs.push(getForSaleTab({...args, tabIndex})),
    tabIndex++;
    if (hasUnderContract) {
        tabs.push(getUnderContractsTab({...args, tabIndex}));
        tabIndex++;
    }
    hasSold && tabs.push(getSoldTab({...args, tabIndex}));
    return tabs;
};

export const getListingTabsByStatus = ({selectedListingViewId, ...args}) => {
    let tabs = [];
    if(selectedListingViewId === soldAvgVsMedianPrice.value) tabs = [getSoldTab(args)];
    if(selectedListingViewId === avgSpOpComparison.value) tabs = [getSoldTab(args)];
    if(selectedListingViewId === avgSpLpComparison.value) tabs = [getSoldTab(args)];
    if(selectedListingViewId === avgSpOpAllProperties.value) tabs = [getSoldTab(args)];
    if(selectedListingViewId === salesAbsorption.value) tabs = buildSalesAbsortionTabs(args);
    if(selectedListingViewId === underContractUc.value) tabs = [getUnderContractsTab(args)];
    if(selectedListingViewId === avgDomCdom.value) tabs = [getUnderContractsTab(args)];
    if(selectedListingViewId === monthlySupplyOfInventory.value) tabs = buildmonthlySupplyOfInventoryTabs(args);
    return tabs
};

export const listingBreakdownViewsIds = [
    medianPrice.value,
    avg$Sqft.value,
    supplyAmpDemandNumUnits.value,
    forSaleVsFsldm.value,
];
